import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Link/Link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CandidatRechercheFilters"] */ "/app/ui/app/(candidat)/recherche/_components/CandidatRechercheFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CandidatRechercheForm"] */ "/app/ui/app/(candidat)/recherche/_components/CandidatRechercheForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RechercheResultats"] */ "/app/ui/app/(candidat)/recherche/_components/RechercheResultats.tsx");
